var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _path6, _rect7, _rect8, _rect9, _path7, _path8, _polygon, _polygon2, _path9, _path10, _path11, _circle4, _polygon3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polygon4, _polygon5, _path19, _path20, _path21, _path22, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCampaignsEmptyState = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aced5027-7764-4d9c-85f3-702f4c5cb940",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000.14899,
    height: 500.05157,
    viewBox: "0 0 1000.14899 500.05157",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "send_gift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.02399,
    y: 484.02579,
    width: 299,
    height: 2,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.43367,686.93692l-.56866-1.25073c-.12458-.27523-12.39765-27.79381-4.43344-54.39815,7.96462-26.60557,33.33975-42.85309,33.59469-43.01367l1.16258-.733.56825,1.25031c.12458.27523,12.39723,27.7934,4.43344,54.39815-7.96463,26.60558-33.33975,42.85309-33.5947,43.01367Zm-2.70509-54.961c-6.73417,22.49373,1.497,45.70718,3.77041,51.40086,5.02693-3.51214,24.66739-18.40214,31.39453-40.87476,6.7263-22.47013-1.49948-45.70138-3.77041-51.40086C156.09328,594.61536,136.4553,609.50453,129.72858,631.9759Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.76969,633.1953c6.6724,26.82639-6.89256,53.29279-6.89256,53.29279s-24.38306-17.02777-31.05546-43.85415,6.89255-53.29279,6.89255-53.29279S133.09728,606.36892,139.76969,633.1953Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#ff5722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.875,600.97421h-590a6.00656,6.00656,0,0,1-6-6v-363a6.00657,6.00657,0,0,1,6-6h590a6.00657,6.00657,0,0,1,6,6v363A6.00656,6.00656,0,0,1,1007.875,600.97421Zm-590-373a4.00458,4.00458,0,0,0-4,4v363a4.00426,4.00426,0,0,0,4,4h590a4.004,4.004,0,0,0,4-4v-363a4.00428,4.00428,0,0,0-4-4Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.825,199.97421h-595.9a5.0252,5.0252,0,0,0-5.05,5v34h606v-34A5.0252,5.0252,0,0,0,1010.825,199.97421Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#ff5722"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 843.08946,
    cy: 19,
    r: 6.19048,
    fill: "#d0cde1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 862.89899,
    cy: 19,
    r: 6.19048,
    fill: "#d0cde1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 882.70851,
    cy: 19,
    r: 6.19048,
    fill: "#d0cde1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M728.875,497.97421h-278v-204h278Zm-276-2h274v-200h-274Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 693.89899,
    y: 143,
    width: 64,
    height: 11,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 746.89899,
    y: 247,
    width: 64,
    height: 11,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 693.89899,
    y: 175,
    width: 180,
    height: 11,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 693.89899,
    y: 193,
    width: 180,
    height: 11,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 693.89899,
    y: 211,
    width: 180,
    height: 11,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M969.33106,560.49557c5.23617-4.5654,13.68348-8.87562,20.49164-11.39947-6.80816-2.52619-15.25547-6.8364-20.49164-11.4018l3.69051,10.20309H953.875v2.39743h19.1465Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 225.64899,
    y: 399,
    width: 774.5,
    height: 2,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 432.1704,
    y: 152.81177,
    width: 119.45718,
    height: 111.69246,
    fill: "#ff5722"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 479.35598,
    y: 149.82534,
    width: 25.08601,
    height: 118.26261,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M588.27883,327.4291c8.01033,6.87471,5.55715,22.8725,5.55715,22.8725s-15.44049,4.85168-23.45082-2.023-5.55714-22.87251-5.55714-22.87251S580.26851,320.55438,588.27883,327.4291Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M614.87062,346.76808c-6.84968,8.03175-22.85505,5.62852-22.85505,5.62852s-4.89986-15.42527,1.94982-23.457,22.85505-5.62852,22.85505-5.62852S621.72029,338.73633,614.87062,346.76808Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "102.399 460.5 103.399 469.5 94.399 468.5 94.399 457.5 102.399 460.5",
    fill: "#ffb8b8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.399 460.5 195.399 469.5 204.399 468.5 204.399 457.5 196.399 460.5",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.375,466.47421l-4,103s-13,77-10,79,0,13,0,13l17,2s0-8,4-11,41-144,41-144l38,136s-1,8,2,8,4,11,4,11h17v-11s5-1,2-9-14-177-14-177Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.375,660.47421s-5-3-7-1-18,22-18,22-22,14-2,18,35-15,36-17-1-18-2-16-4,1-5,0S196.375,660.47421,196.375,660.47421Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M302.375,660.47421s5-3,7-1,18,22,18,22,22,14,2,18-35-15-36-17,1-18,2-16,4,1,5,0S302.375,660.47421,302.375,660.47421Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.89899,
    cy: 98,
    r: 20.5,
    fill: "#ffb8b8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "148.399 109.5 145.399 140.5 169.399 145.5 175.399 108.5 148.399 109.5",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M273.375,333.47421s-6,13-28-1l-41,134s55,33,90,8l-12-135Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#575a89"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M249.375,318.47421l-19-3-2,13s-26,3-29,13l3,74s-9,16-1,26c0,0-13,27-3,32,0,0,23-11,37-8,0,0,8-2,8-8S249.375,318.47421,249.375,318.47421Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M272.375,320.47421l11,3,1,14s27,17,28,27-20,58-20,58,8,14,5,23c0,0,13,26,5,33,0,0-15,4-17-2s-20-75-12-108C273.375,368.47421,265.375,326.47421,272.375,320.47421Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M283.875,353.04091h-.37639V342.7298a5.96779,5.96779,0,0,0-5.96781-5.96779H255.68533a5.96779,5.96779,0,0,0-5.96781,5.96779v56.56756a5.96779,5.96779,0,0,0,5.96781,5.9678H277.5308a5.96779,5.96779,0,0,0,5.96781-5.9678V360.38054h.37639Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M293.375,393.47421s-8-26-20-18,8,30,8,30Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M238.375,374.47421s14-17,21-9-12,26-12,26Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M202.375,340.47421s-5-1-8,8-14,43-14,49,4,30,26,26,48-32,48-32l-14-21-30,18Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "106.72 166.425 110.899 188 141.899 170 112.899 181 106.505 165.138 106.72 166.425",
    opacity: 0.1
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "194.899 188 198.899 191 200.899 177 194.899 188",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201.875,425.97421s29.37274-7.9907,43.18637-25.49535C245.06137,400.47886,230.875,423.97421,201.875,425.97421Z",
    transform: "translate(-99.97601 -199.97421)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M275.875,407.97421s6.18509,30.27011,22.09255,31.13506C297.96755,439.10927,278.875,444.97421,275.875,407.97421Z",
    transform: "translate(-99.97601 -199.97421)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M308.375,360.47421s3,2,5,11,15,43,10,51-13,26-30,14l-17-31,17-16,7,5Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M242.195,303.17349s-17.19286-27.86435,1.11989-29.3136a46.68751,46.68751,0,0,0,17.56178-4.7852c6.07025-3.08892,13.71127-5.43681,17.77741-.6818a30.21473,30.21473,0,0,0,6.1465,5.69412c3.57181,2.36878,7.70454,6.20882,5.41608,10.328l-3.75169,6.753-5.2524,13.50608c1.22315-5.82554,1.25391-10.71679-1.87585-13.13092,0,0-17.46167,7.431-26.26172-6.0027C243.22388,278.14928,240.08972,301.41365,242.195,303.17349Z",
    transform: "translate(-99.97601 -199.97421)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.89899,
    cy: 157,
    r: 5,
    fill: "#ff5722"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCampaignsEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/campaigns-empty-state.05366cf1dd537732fbc95d4a493a52e0.svg";